import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuthContext from '../../contexts/AuthContext';
import useErrorMessage from '../../utils/ErrorMessage';
import { ContentCustom, PageHeader } from '../../components';
import QuittanceTable from '../contracts/QuittanceTable';

const Unpaid = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [contract, setContract] = useState();
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();

  useEffect(() => {
    (async () => {
      const id = location.pathname.split('/');
      try {
        const { data } = await dispatchAPI('GET', {
          url: `/contracts/${id[3]}?populate=exemption.assignee file ticket_messages.author,insurer,quittances,amendment.insurer previous_contract`
        });
        setContract(data);
      } catch (e) {
        if (e.response) message(e.response.status);
      }
    })();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <PageHeader title={t('quittances.title')} />
      <ContentCustom>
        <Typography.Paragraph level={4}>
          {t('quittances.form.title')}
        </Typography.Paragraph>
        <QuittanceTable data={contract && contract.quittances} />
      </ContentCustom>
    </>
  );
};

export default Unpaid;
